import { IKContext, IKImage } from "imagekitio-react";
import { useState } from "react";
import "./FastImage.css";

const FastImage = ({
  url = "/default-img.jpg",
  alt = "",
  width = 200,
  height = 200,
  isLazy = true,
  isLCP = false,
  className = "",
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <IKContext
      urlEndpoint="https://ik.imagekit.io/teofx8bxs"
      publicKey="public_cByGWF64WLo1UVjA1cd/XCatNkw="
    >
      <div
        style={{
          width: width || "auto",
          height: height || "auto",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <IKImage
          path={url}
          alt={alt}
          width={width}
          height={height}
          className={className}
          style={{
            visibility: loaded ? "visible" : "hidden",
          }}
          onLoad={() => setLoaded(true)}
          transformation={[
            {
              f: "webp",
              q: "auto",
              width: width,
              height: height,
            },
          ]}
          // loading={isLCP ? "eager" : isLazy ? "lazy" : "eager"}
          // fetchpriority={isLCP ? "high" : "auto"}
        />
      </div>
    </IKContext>
  );
};

export default FastImage;
